<div class="padding-b-70 wow fadeIn"
     data-wow-duration="500ms">
   <div class="pageBanner missionCapital"></div>

   <div class="">
      <div class="border-bottom">
         <div class="pageTabs flex hr-center sapientsansmedium font-15">
            <a routerLink="/missionCapital/details"
               [ngClass]="{'active': path?.currentRout('missionCapital/details')}" class="wow fadeInUp"
               data-wow-duration="500ms" data-wow-delay="100ms">Mission Capital</a>
            <!-- <a routerLink="/missionCapital/looking-for"
               [ngClass]="{'active': path?.currentRout('missionCapital/looking-for')}" class="wow fadeInUp"
               data-wow-duration="500ms" data-wow-delay="300ms">What We Look For</a> -->
            <!-- <a routerLink="/missionCapital/capital-investment"
               [ngClass]="{'active': path?.currentRout('missionCapital/capital-investment')}" class="wow fadeInUp"
               data-wow-duration="500ms" data-wow-delay="300ms">Our Investments</a> -->
         </div>
      </div>
   </div>


   <router-outlet></router-outlet>

</div>
